<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <base-v-component
      heading="Log Books"
      link="components/simple-tables"
    />

    <base-material-card
      icon="mdi-clipboard-text"
      title="Log Books"
      class="px-5 py-3"
    >
      <div class="d-flex justify-end">
        <v-col
          class="d-flex align-self-end"
          cols="12"
          sm="2"
        >
          <v-select
            v-model="selectedType"
            :items="types"
            label="Department"
            item-text="name"
            item-value="value"
            outlined
            @change="changeSystem"
          />
        </v-col>
      </div>
      <h2
        v-if="selectedType=='finish-analytics' || selectedType=='all'"
      >
        Finish
      </h2>
      <div
        v-if="selectedType=='finish-analytics' || selectedType=='all'"
      >
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row">
          <div
            v-for="(value,acctmgr) in finishLogBooks"
            :key="acctmgr"
            class="col-12"
          >
              <h3
                v-if="acctmgr!=''"
              >
                {{ acctmgr }}
              </h3>
              <table
                v-if="acctmgr!=''"
                style="width:100%"
              >
                <thead>
                  <tr>
                   <th class="primary--text">
                      <p>Year</p>
                    </th>
                    <th class="primary--text">
                      <p>Month</p>
                    </th>
                    <th class="primary--text">
                      <p>Count</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record,index) in value"
                    :key="index"
                    class="text-center"
                  >
                    <td>{{ record.YR }}</td>
                    <td>{{ record.MNTH }}</td>
                    <td>{{ record.CNT }}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </section>
      </div>

      <h2
        v-if="selectedType=='aqua-analytics' || selectedType=='all'"
      >
        Aqua
      </h2>
      <div
        v-if="selectedType=='aqua-analytics' || selectedType=='all'"
      >
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row">
          <div
            v-for="(value,acctmgr) in aquaLogBooks"
            :key="acctmgr"
            class="col-12"
          >
            <!--td>{{ customer.line }}</td-->
              <h3
                v-if="acctmgr!=''"
              >
                {{ acctmgr }}
              </h3>
              <table
                v-if="acctmgr!=''"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="primary--text">
                      <p>Year</p>
                    </th>
                    <th class="primary--text">
                      <p>Month</p>
                    </th>
                    <th class="primary--text">
                      <p>Count</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record,index) in value"
                    :key="index"
                    class="text-center"
                  >
                    <td>{{ record.YR }}</td>
                    <td>{{ record.MNTH }}</td>
                    <td>{{ record.CNT }}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </section>
      </div>
      <h2
        v-if="selectedType=='metal-analytics' || selectedType=='all'"
      >
        Metal
      </h2>
      <div
        v-if="selectedType=='metal-analytics' || selectedType=='all'"
      >
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row ">
          <div
            v-for="(value,acctmgr) in metalLogBooks"
            :key="acctmgr"
            class="col-md-12"
          >
              <h3
                v-if="acctmgr!=''"
              >
                {{ acctmgr }}
              </h3>
              <table
                v-if="acctmgr!=''"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="primary--text">
                      <p>Year</p>
                    </th>
                    <th class="primary--text">
                      <p>Month</p>
                    </th>
                    <th class="primary--text">
                      <p>Count</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record,index) in value"
                    :key="index"
                    class="text-center"
                  >
                    <td>{{ record.YR }}</td>
                    <td>{{ record.MNTH }}</td>
                    <td>{{ record.CNT }}</td>
                  </tr>
                </tbody>
              </table>

          </div>
        </section>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
  import Axios from 'axios'
  import { constants } from '../../../constants'
  export default {
    name: 'DashboardPagesTimeline',
    data: () => ({
      selectedType: 'finish-analytics',
      types: [{ name: 'Finish', value: 'finish-analytics' }, { name: 'Aqua', value: 'aqua-analytics' }, { name: 'Metal', value: 'metal-analytics' }, { name: 'All', value: 'all' }],
      menu: false,
      finishLogBooks: [],
      aquaLogBooks: [],
      metalLogBooks: [],
    }),
    created () {
      Axios.get(constants.VUE_APP_BASEURL + '/logbooks?type=finish-analytics').then(res => {
        this.finishLogBooks = res.data.logBooks.filter(customer => customer.line === 'finish-analytics')
        this.finishLogBooks = this.finishLogBooks.reduce(function (r, a) {
          r[a.acctmgr] = r[a.acctmgr] || []
          r[a.acctmgr].push(a)
          return r
        }, Object.create(null))
      })
    },
    methods: {
      changeSystem (a) {
        Axios.get(constants.VUE_APP_BASEURL + '/logbooks?type=' + a).then(res => {
          if (a === 'all') {
            this.finishLogBooks = res.data.logBooks.filter(customer => customer.line === 'finish-analytics')
            this.finishLogBooks = this.finishLogBooks.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.aquaLogBooks = res.data.logBooks.filter(customer => customer.line === 'aqua-analytics')
            this.aquaLogBooks = this.aquaLogBooks.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.metalLogBooks = res.data.logBooks.filter(customer => customer.line === 'aqua-analytics')
            this.metalLogBooks = this.metalLogBooks.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
          } else if (a === 'finish-analytics') {
            this.finishLogBooks = res.data.logBooks.filter(customer => customer.line === 'finish-analytics')
            this.finishLogBooks = this.finishLogBooks.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.metalLogBooks = []
            this.aquaLogBooks = []
          } else if (a === 'metal-analytics') {
            this.metalLogBooks = res.data.logBooks.filter(customer => customer.line === 'finish-analytics')
            this.metalLogBooks = this.metalLogBooks.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.finishLogBooks = []
            this.aquaLogBooks = []
          } else if (a === 'aqua-analytics') {
            this.aquaLogBooks = res.data.logBooks.filter(customer => customer.line === 'finish-analytics')
            this.aquaLogBooks = this.aquaLogBooks.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.finishLogBooks = []
            this.metalLogBooks = []
          }
        })
      },
    },
  }
</script>
<style>
 tr:nth-child(even) {
    background: #eee;
}
th.primary--text {
    font-size: 16px !important;
}

th.primary--text p {
    font-size: 0.90rem;
}
</style>
